/** Origin the cart is served from — also the only origin we accept `postMessage` from. */
export const MBO_CART_ORIGIN = 'https://cart.mindbodyonline.com';

/**
 * Where Mindbody sends the sign-in window once the user is authenticated.
 *
 * `embedded_url` is not only the `postMessage` target origin — Mindbody also redirects back to
 * it after sign-in. Sending a bare origin lands the sign-in window on the app's own root with
 * no launch params, which boots the miniapp straight into its error page. Pointing it at a
 * dedicated path lets `index.tsx` recognise the returning window and close it instead.
 *
 * Still no query string and nothing about which page the user came from, so this keeps the
 * "don't hand Mindbody the embedding page's URL" property — it is a fixed marker, not a href.
 */
export const MBO_SIGNIN_RETURN_PATH = '/mbo-signin-return';

/**
 * Sign-in window geometry. Mindbody asks for 800x768 and centres on the browser window; we
 * keep the same size so their pages get the viewport they were designed against.
 */
export const MBO_POPUP_WIDTH = 800;
export const MBO_POPUP_HEIGHT = 768;

/**
 * Destination overrides, keyed by the Mindbody path with the site id removed — e.g.
 * `/sites/16805/cart/add_booking` keys as `cart/add_booking`.
 *
 * Mindbody's `data-url` is not always where the user should actually land. Anything listed
 * here replaces the destination; the original query string is carried over, so the override
 * only needs to be the path-or-absolute-URL to send the user to. Leave a key out to use
 * Mindbody's own `data-url` untouched.
 *
 * Empty for now — pending the per-page destination list from the ARE/Mindbody side.
 */
export const MBO_DESTINATION_OVERRIDES: Record<string, string> = {};
